import { CALL_API, CONTENT_TYPE } from 'middlewares/api';
import { url } from 'configs';
import { buildPageMeta } from 'containers/App/screens/Tube/utils';
import { downloadFile } from 'containers/App/screens/Tube/utils/downloadFile';

const { NEWTUBE_API_SERVER } = url;

const FETCH_GETTOMEDATALIST_REQUEST = 'tube/assignmenttask/received/FETCH_GETTOMEDATALIST_REQUEST';
const FETCH_GETTOMEDATALIST_SUCCESS = 'tube/assignmenttask/received/FETCH_GETTOMEDATALIST_SUCCESS';
const FETCH_GETTOMEDATALIST_ERROR = 'tube/assignmenttask/received/FETCH_GETTOMEDATALIST_ERROR';

const FETCH_GETTOMEDATA_REQUEST = 'tube/assignmenttask/received/FETCH_GETTOMEDATA_REQUEST';
const FETCH_GETTOMEDATA_SUCCESS = 'tube/assignmenttask/received/FETCH_GETTOMEDATA_SUCCESS';
const FETCH_GETTOMEDATA_ERROR = 'tube/assignmenttask/received/FETCH_GETTOMEDATA_ERROR';

const POST_DOWNLOADEXCEL_REQUEST = 'tube/assignmenttask/received/POST_DOWNLOADEXCEL_REQUEST';
const POST_DOWNLOADEXCEL_SUCCESS = 'tube/assignmenttask/received/POST_DOWNLOADEXCEL_SUCCESS';
const POST_DOWNLOADEXCEL_ERROR = 'tube/assignmenttask/received/POST_DOWNLOADEXCEL_ERROR';

const POST_MESSAGE_REQUEST = 'tube/assignmenttask/received/POST_MESSAGE_REQUEST';
const POST_MESSAGE_SUCCESS = 'tube/assignmenttask/received/POST_MESSAGE_SUCCESS';
const POST_MESSAGE_ERROR = 'tube/assignmenttask/received/POST_MESSAGE_ERROR';

const PUT_GETTOMESTATUS_REQUEST = 'tube/assignmenttask/received/PUT_GETTOMESTATUS_REQUEST';
const PUT_GETTOMESTATUS_SUCCESS = 'tube/assignmenttask/received/PUT_GETTOMESTATUS_SUCCESS';
const PUT_GETTOMESTATUS_ERROR = 'tube/assignmenttask/received/PUT_GETTOMESTATUS_ERROR';

const UPLOAD_MESSAGE_FILE_REQUEST = 'tube/assignmenttask/received/UPLOAD_MESSAGE_FILE_REQUEST';
const UPLOAD_MESSAGE_FILE_SUCCESS = 'tube/assignmenttask/received/UPLOAD_MESSAGE_FILE_SUCCESS';
const UPLOAD_MESSAGE_FILE_ERROR = 'tube/assignmenttask/received/UPLOAD_MESSAGE_FILE_ERROR';

const POST_NEWMESSAGE_REQUEST = 'tube/assignmenttask/received/POST_NEWMESSAGE_REQUEST';
const POST_NEWMESSAGE_SUCCESS = 'tube/assignmenttask/received/POST_NEWMESSAGE_SUCCESS';
const POST_NEWMESSAGE_ERROR = 'tube/assignmenttask/received/POST_NEWMESSAGE_ERROR';

const UPLOAD_MAINMESSAGE_FILE_REQUEST = 'tube/assignmenttask/received/UPLOAD_MAINMESSAGE_FILE_REQUEST';
const UPLOAD_MAINMESSAGE_FILE_SUCCESS = 'tube/assignmenttask/received/UPLOAD_MAINMESSAGE_FILE_SUCCESS';
const UPLOAD_MAINMESSAGE_FILE_ERROR = 'tube/assignmenttask/received/UPLOAD_MAINMESSAGE_FILE_ERROR';

export default function reducer(state = {
  gettomeList: {
    isLoadingList: false,
    data: [],
  },
  gettome: {
    isLoadingData: false,
    data: {},
  },
  pageMeta: {},
}, action) {
  switch (action.type) {
    case FETCH_GETTOMEDATALIST_REQUEST:
      return Object.assign({}, state, {
        gettomeList: {
          isLoadingList: true,
        },
      });
    case FETCH_GETTOMEDATALIST_SUCCESS:
      return Object.assign({}, state, {
        gettomeList: {
          isLoadingList: false,
          data: action.response.data,
        },
        pageMeta: buildPageMeta(action.response.meta),
      });
    case FETCH_GETTOMEDATA_REQUEST:
      return Object.assign({}, state, {
        gettome: {
          isLoadingData: true,
        },
      });
    case FETCH_GETTOMEDATA_SUCCESS:
      return Object.assign({}, state, {
        gettome: {
          isLoadingData: false,
          data: action.response.data,
        },
      });
    default:
      return state;
  }
}

// 列表
export function fetchGetToMeDataList(pageNumber) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'assignment/GetToMe?PageNumber=' + pageNumber,
      method: 'GET',
      headers: {
        functionCode: 'AssignmentTask',
        actionCode: 'Default',
      },
      types: [
        FETCH_GETTOMEDATALIST_REQUEST,
        FETCH_GETTOMEDATALIST_SUCCESS,
        FETCH_GETTOMEDATALIST_ERROR,
      ],
    },
  };
}

// 單筆
export function fetchGetToMeData(AssignmentId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'assignment/GetToMe/' + AssignmentId,
      method: 'GET',
      headers: {
        functionCode: 'AssignmentTask',
        actionCode: 'Default',
      },
      types: [
        FETCH_GETTOMEDATA_REQUEST,
        FETCH_GETTOMEDATA_SUCCESS,
        FETCH_GETTOMEDATA_ERROR,
      ],
    },
  };
}

// 下載報表
export function postDownloadExcel(AssignmentIdArray) {
  const downloadUrl = NEWTUBE_API_SERVER + 'Assignment/DownloadExcel';
  const types = [
    POST_DOWNLOADEXCEL_REQUEST,
    POST_DOWNLOADEXCEL_SUCCESS,
    POST_DOWNLOADEXCEL_ERROR,
  ];
  const params = AssignmentIdArray;
  const method = 'POST';
  return downloadFile(downloadUrl, types, params, method);
}

// 回覆訊息
export function postMessage(AssignmentId, message) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Assignment/' + AssignmentId + '/Message',
      method: 'POST',
      headers: {
        functionCode: 'AssignmentTask',
        actionCode: 'Default',
      },
      types: [
        POST_MESSAGE_REQUEST,
        POST_MESSAGE_SUCCESS,
        POST_MESSAGE_ERROR,
      ],
      params: {
        Message: message,
      },
    },
  };
}

// 更改狀態
export function putGetToMeStatus(assignmentId, status) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Assignment/GetToMe/' + assignmentId + '/' + status,
      method: 'PUT',
      headers: {
        functionCode: 'AssignmentTask',
        actionCode: 'Default',
      },
      types: [
        PUT_GETTOMESTATUS_REQUEST,
        PUT_GETTOMESTATUS_SUCCESS,
        PUT_GETTOMESTATUS_ERROR,
      ],
    },
  };
}

// 下載附件
export function downloadAttachment(apiUrl) {
  let downloadUrl = apiUrl.split('api/')[1];
  downloadUrl = NEWTUBE_API_SERVER + downloadUrl;
  return downloadUrl;
}

// 上傳訊息附件
export function uploadMessageFile(AssignmentId, messageId, formData) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Assignment/' + AssignmentId + '/Message/' + messageId + '/Attachment',
      method: 'POST',
      headers: {
        functionCode: 'AssignmentTask',
        actionCode: 'Default',
      },
      types: [
        UPLOAD_MESSAGE_FILE_REQUEST,
        UPLOAD_MESSAGE_FILE_SUCCESS,
        UPLOAD_MESSAGE_FILE_ERROR,
      ],
      contentType: CONTENT_TYPE.FORM,
      params: formData,
    },
  };
}

// 新增訊息
export function postNewMessage(data) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Assignment/GetFromMe',
      method: 'POST',
      headers: {
        functionCode: 'AssignmentTask',
        actionCode: 'Default',
      },
      types: [
        POST_NEWMESSAGE_REQUEST,
        POST_NEWMESSAGE_SUCCESS,
        POST_NEWMESSAGE_ERROR,
      ],
      params: data,
    },
  };
}

// 上傳主體附件
export function uploadMainMessageFile(AssignmentId, formData) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Assignment/GetFromMe/' + AssignmentId + '/Attachment',
      method: 'POST',
      headers: {
        functionCode: 'AssignmentTask',
        actionCode: 'Default',
      },
      types: [
        UPLOAD_MAINMESSAGE_FILE_REQUEST,
        UPLOAD_MAINMESSAGE_FILE_SUCCESS,
        UPLOAD_MAINMESSAGE_FILE_ERROR,
      ],
      contentType: CONTENT_TYPE.FORM,
      params: formData,
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/AssignmentTask/screens/Received/reducers/index.js
 **/